import React, { Component } from "react";
import styled from "styled-components";
import InputSec from "../module-common/MessageInput";
import LiveChatLogo from "../assets/LiveChatLogo.png";

export default class Footer extends Component {
  render() {
    return (
      <Wrapper>
        <InputSec />
        <FooterWrapper>
          <FooterText>We run on</FooterText>
          <LogoLiveChat alt="logo care" src={LiveChatLogo} />
        </FooterWrapper>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 60px;
  width: 100%;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  @media (max-width: 430px) {
    display: flex;
    flex-direction: column;
    height: 13%;
    width: 100%;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  @media (max-height: 420px) {
    display: flex;
    flex-direction: column;
    height: 16%;
    width: 100%;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`;

const FooterText = styled.div`
  display: flex;
  margin: 6px;
  color: #c6c6c6;
  font-size: 10px;
  font-family: "Source Sans Pro", sans-serif;
  font-style: Regular;
`;
const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-self: center;
  align-items: center;
  align-content: center;
`;
const LogoLiveChat = styled.img`
  display: flex;
  justify-content: center;
  align-self: center;
  width: 44.43px;
  height: 9.97px;
`;



// WEBPACK FOOTER //
// ./src/chat/Footer.js